module.exports = __webpack_public_path__ + "assets/rss-icon.3d88313a.svg";